export const MAX_APP_CONTAINER_WIDTH_NEW = '1920px';
export const FULL_SCREEN_SLIDE_OUT_WIDTH = '95vw';
